import { useCallback } from 'react';

import { useMobileNativeShare } from './useMobileNativeShare';

type UsePetitionHeadingMobileData = Readonly<Record<string, unknown>>;

type UsePetitionHeadingMobileActions = { handleShare: () => Promise<void> };
type UsePetitionHeadingMobileReturn = ModelHookResult<UsePetitionHeadingMobileData, UsePetitionHeadingMobileActions>;

export function usePetitionHeadingMobile(): UsePetitionHeadingMobileReturn {
	const shareAction = useMobileNativeShare();
	const handleShare = useCallback(async () => {
		await shareAction?.action();
	}, [shareAction]);

	return {
		data: {},
		actions: { handleShare },
	};
}
